import { supabaseGestionPension as supabase } from '../config/settings/supabase-client'
import { getLogger } from '../core/debuggers'
import { mapProfileFromDb } from '../mappers/profile.mapper'

const logger = getLogger('profile.js')

/**
 * Gets user profile.
 */
export async function fetchUserProfile({ id }) {
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', id)
    .single()

  if (error) {
    logger.error('Supabase error:', error)
    throw error
  }

  return mapProfileFromDb(data)
}

/**
 * Skip onboarding
 */
export const setSkipOnboarding = async ({ userId }) => {
  const { error } = await supabase
    .from('profiles')
    .update({
      onboarding_status: 'skipped', // 'pending' | 'skipped' | 'completed'
    })
    .eq('id', userId)

  if (error) throw error

  return true
}

/**
 * Set onboarding status
 */
export const setOnboardingStatus = async ({ userId, status }) => {
  const { error } = await supabase
    .from('profiles')
    .update({
      onboarding_status: status, // 'pending' | 'skipped' | 'completed'
    })
    .eq('id', userId)

  if (error) throw error

  return true
}
